export default {
  alertsrowsdata: [],
  amountOfFetchedAlerts: -1,
  totalOfFetchedAlerts: -1,
  alertsCountByEntity: {},
  alertsCountByDate: [],
  comments: {},
  userName: '',
  selectedAlertRows: [],
  selectedSeverities: {
    Critical: true,
    High: true,
    Medium: false,
    Low: false,
    Informative: false
  },
  processTree: {}
};
